import { matchRoutes, useLocation, useMatches } from "react-router";
import { useAuthenticatedUser } from "src/contexts/AuthenticatedUserContext";
import { useRouteLabels } from "src/contexts/RouteLabelsContext";
import { resolveRouteMetadata } from "src/routes/metadata";
import type { RouteMatchLike } from "src/routes/metadata";
import type { AppRouteHandle } from "src/routes/types";
import { decoratedAppRouteChildren } from "src/routes/routeRegistry";

export const useRouteMetadata = () => {
    const uiMatches = useMatches();
    const location = useLocation();
    const routeMatches = matchRoutes(decoratedAppRouteChildren, location) ?? [];
    const routeOffset = uiMatches[0]?.pathname === "/" ? 1 : 0;
    const matches: RouteMatchLike[] = uiMatches.map((match, index) => ({
        pathname: match.pathname,
        params: match.params,
        handle: match.handle as AppRouteHandle | undefined,
        route: routeMatches[index - routeOffset]?.route,
    }));
    const { labels } = useRouteLabels();
    const { permissions } = useAuthenticatedUser();
    return resolveRouteMetadata(matches, labels, permissions);
};

export const getRouteHandle = (matches: readonly { handle?: unknown }[], index: number): AppRouteHandle | undefined => {
    const handle = matches[index]?.handle;
    return handle && typeof handle === "object" ? handle as AppRouteHandle : undefined;
};

export default useRouteMetadata;
